<template>
  <div  class="result-page">
    <div class="share-box" v-show="showShare" @click="showShare=false">
    </div>
    <div class="img-box">
      <CanvasToImg ref='img' :texts = texts :imgNum = imgNum animate="fadeIn" @loaded="imgLoaded"> </CanvasToImg>
    </div>
    <div class="shadow-box" v-show="showShadow">
      <img class="tips-img img-point" src="../assets/tips.png"/>
      <div class="btn-group">
        <div class="btn btn-again" @click="!clicked && playAgain()" data-rlog="playAgain"></div>
        <div class="btn btn-share" @click="showShare=true"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Result',
  data () {
    return {
      texts: [
      ],
      imgNum: 2,
      showShare: false,
      showShadow: false,
      clicked: false,
    }
  },
  created() {

//    const avatar = require('@/assets/avatar.png')
//    this.$preloadImg({
//      src: `./static/result/1.png`,
//      isBg: true,
//      name: 'bg'
//    })
//    this.$preloadImg({
//      src: avatar,
//      x: 103,
//      y: 103,
//      h: 55,
//      w: 55,
//      z: -1
//    })

    const name = this.$route.query.name
    const len = this.$getRealLength(name)
    let fz = 36
    console.log(len)
    if(len > 18){ fz = 20 }
    else if(len > 16){ fz = 22 }
    else if(len > 14){ fz = 24 }
    else if(len > 13){ fz = 26 }
    else if(len > 12){ fz = 30 }
    else if(len > 11){ fz = 32 }

    var c=document.createElement('canvas')
    var ctx=c.getContext("2d");
    ctx.font= `${fz}px Microsoft-Yahei`;
    const x = 290 - ctx.measureText(name).width/2

    const nameObj = {
      content: name,
      x,
      y: 144,
      fz,
      color: '#c4a974',
    }
    this.texts.push(nameObj)
  },
  methods: {
    playAgain() {
      this.clicked = true
      // this.$router.go(-2)
      this.$router.go(-1)
    },
    imgLoaded() {
      this.showShadow = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .result-page {
    position: relative;
    width: 100%;
    height: 100%;
    background: url(../assets/bg.png) 0 0/100% 100% no-repeat;
    overflow: hidden;
  }
  .shadow-box {
    padding-top: 0.2rem;
    height: 1.5rem;
    box-sizing: border-box;
  }
  .tips-img {
    display: block;
    margin: 0 auto 0.1rem;
    width: 3.4rem;
  }
  .btn-group {
    text-align: center;
    line-height: 1;
  }
  .btn {
    width: 1.9rem;
    height: 0.61rem;
    display: inline-block;
    background: url(../assets/btnShare.png) 0 0 /contain no-repeat;
  }
  .btn-again {
    margin-right: 0.6rem;
    background-image: url(../assets/btnAgain.png)
  }
  .img-box {
    position: relative;
    height: calc(100% - 1.5rem);
    width: 100%;
  }
  .share-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url(../assets/share.png) rgba(0,0,0,0.8)  88% 5% / 50% 11% no-repeat;
    z-index: 10;
  }

  @media screen and (min-height: 760px){
    .tips-img {
      width: 4.2rem;
      margin-bottom: 0.3rem;
    }
    .img-box {
      height: calc(100% - 2.2rem)
    }
    .btn {
      width: 2.16rem;
      height: 0.68rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Result.vue